<template>
  <div id="publicSettingDiv">
    <div class="publicSettingDiv_content">
      <div class="head_title publicSetting_head_title">
        <div class="head_title_font publicSetting_head_title_font">教学地点设置</div>
      </div>
      <div class="body_content publicSetting_body_content">
        <div>
          <button type="button" class="btn btn-default btn_option button1" data-toggle="modal" data-target="#addPlaceModal" @click="place.id='';place.name='';place.type=''">+ 新增教学场地</button>
        </div>
        <div class="content_one" v-for="(query,index) in RoomList" :key="index">
          <div class="box1">
            {{query.name}}({{query.type == 1 ?'校内':'校外'}})
            <span @click="deletePlace(query.id)">
              <img src="../assets/img/right/clazz/delete_mouseOver.png"/>
            </span>
            <span @click="current_placeId=query.id;place.name=query.name;place.type=query.type" data-toggle="modal" data-target="#updatePlaceModal">
              <img src="../assets/img/right/clazz/edit_mouseOver.png"/>
            </span>
          </div>
          <span class="box2" v-for="room in query.rooms">
            <button type="button" class="btn btn-default button2">
              {{room.name}}
            </button>
            <div class="glyphicon glyphicon-remove" @click="deleteRoomId=room.id;deleteRoomById()"></div>
          </span>
          <button type="button" class="btn btn-default btn_option" data-toggle="modal" data-target="#roomModel" style="margin: 10px 0 10px 30px" @click="current_placeId=query.id,openAddRoomModal()">+ 新增</button>
        </div>
      </div>
      <!--新增教学场地-->
      <div class="modal fade" id="addPlaceModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
              <h4 class="modal-title" id="myModalLabel">新增教学场地</h4>
            </div>
            <div class="modal-body">
              <div id="placeType">
                <label class="my_label">场地类型：</label>
                <select v-validate="'required|maxL:32'" data-vv-scope="place" data-vv-as="场地类型" name="type" class="form-control" v-model="place.type">
                  <option value="1">校内</option>
                  <option value="2">校外</option>
                </select>
                <span class="spanRed">*</span>
                <span class="validateTip">{{ errors.first('place.type') }}</span>
              </div>
              <div>
                <label class="my_label">场地名称：</label>
                <input id="placeName" v-validate="'required'" data-vv-scope="place" data-vv-as="场地名称" name="name" class="form-control" v-model="place.name" placeholder="输入教学场地">
                <span class="spanRed">*</span>
                <span class="validateTip">{{ errors.first('place.name') }}</span>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-default" @click="add_Place()">确认</button>
              <button type="button" class="btn btn-default" data-dismiss="modal">取消</button>
            </div>
          </div><!-- /.modal-content -->
        </div><!-- /.modal -->
      </div>
      <!--修改教学场地-->
      <div class="modal fade" id="updatePlaceModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
              <h4 class="modal-title" id="changePlace">修改教学场地</h4>
            </div>
            <div class="modal-body">
              <div id="updatePlaceType">
                <label class="my_label">场地类型：</label>
                <select v-validate="'required|maxL:32'" data-vv-scope="place" data-vv-as="场地类型" name="type" class="form-control" v-model="place.type">
                  <option value="1">校内</option>
                  <option value="2">校外</option>
                </select>
                <span class="spanRed">*</span>
                <span class="validateTip">{{ errors.first('place.type') }}</span>
              </div>
              <div>
                <label class="my_label">场地名称：</label>
                <input id="updatePlaceName" v-validate="'required'" data-vv-scope="place" data-vv-as="场地名称" name="name" class="form-control" v-model="place.name" placeholder="输入教学场地">
                <span class="spanRed">*</span>
                <span class="validateTip">{{ errors.first('place.name') }}</span>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-default" @click="update_Place()">确认</button>
              <button type="button" class="btn btn-default" data-dismiss="modal">取消</button>
            </div>
          </div><!-- /.modal-content -->
        </div><!-- /.modal -->
      </div>
      <!--新增教室-->
      <div class="modal fade" id="roomModel" tabindex="-1" role="dialog" aria-labelledby="roomModelLabel" aria-hidden="true">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
              <h4 class="modal-title" id="roomModelLabel">新增</h4>
            </div>
            <div class="modal-body">
              <div>
                <label class="my_label">教室编号：</label>
                <input v-validate="'required|maxL:30'" data-vv-scope="rooms" data-vv-as="教室编号" name="name" class="form-control" v-model="rooms.name" placeholder="输入教室编号">
                <span class="spanRed">*</span>
                <span class="validateTip">{{ errors.first('rooms.name') }}</span>
              </div>
              <div>
                <label class="my_label">容纳班级：</label>
                <select v-validate="'required'" data-vv-scope="rooms" data-vv-as="容纳班级" name="clazzNum" class="form-control" v-model="rooms.clazzNum">
                  <option value="1">1</option>
                  <option value="2">2</option>
                  <option value="3">3</option>
                  <option value="0">3+</option>
                </select>
                <span class="spanRed">*</span>
                <span class="validateTip">{{ errors.first('rooms.clazzNum') }}</span>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-default" @click="add_Rooms">确认</button>
              <button type="button" class="btn btn-default" data-dismiss="modal">取消</button>
            </div>
          </div><!-- /.modal-content -->
        </div><!-- /.modal -->
      </div>
    </div>
  </div>
</template>

<script>
  import {getContentSize} from './mainView';
  import {schoolAxios} from "../main"

  export default {
    name: "placeSetting",
    data() {
      return {
        RoomList:[],
        //教学场所对象
        place: {
          id: '',
          name: '',
          type: '',
        },
        /*//修改教学场所对象
        place: {
          id: '',
          name: '',
          type: '',
        },*/
        //教室对象
        rooms: {
          id: '',
          placeId: '',
          name: '',
          clazzNum: '',
        },
        current_placeId: '',

        deleteRoomId:''
      }
    },
    filters: {
    },
    created: function () {
    },
    mounted: function () {
      let this_ = this;
      this.$nextTick(function () {
        getContentSize();
        //刷新页面首次加载
        this_.initRoomListData();

        this_.closeModal();
      });
    },
    methods: {
      /**
       * 查询教室信息
       */
      initRoomListData() {
        let this_ = this;
        schoolAxios({
          method: 'post',
          url: 'place/queryNesting',
          data: {}
        }).then(function (RoomListresp) {
          this_.RoomList = RoomListresp.data.list;
        });
      },

      /**
       * 新增场地
       */
      add_Place(){
        let this_ = this;
        this_.$validator.validateAll('place').then(result => {
          if (result) {
            schoolAxios({
              method: 'post',
              url: 'place/add',
              data: {
                'id': this_.place.id,
                'name': this_.place.name,
                'type': this_.place.type
              }
            }).then(function (resp) {
              let data = resp.data;
              if (data.success) {
                "保存成功".showMessage();
                this_.isAddTeacher = false;
                this_.initRoomListData();
                $("#addPlaceModal").modal("hide");
              } else {
                data.message.showMessage();
              }
            });
          }
        });
      },
      /**
       * 新增教室
       */
      add_Rooms(){
        let this_ = this;
        this_.$validator.validateAll('rooms').then(result => {
          if (result) {
            schoolAxios({
              method: 'post',
              url: 'rooms/add',
              data: {
                'id': this_.rooms.id,
                'name': this_.rooms.name,
                'placeId': this_.current_placeId,
                'clazzNum': this_.rooms.clazzNum
              }
            }).then(function (roomsresp) {
              let data = roomsresp.data;
              if (data.success) {
                "保存成功".showMessage();
                this_.isAddTeacher = false;
                this_.initRoomListData();
                $("#roomModel").modal("hide");
              } else {
                data.message.showMessage();
              }
            });
          }
        });
      },
      /**
       * 删除场地
       */
      deletePlace(id){
        let this_ = this;
        "确定删除".showConfirm(function () {
          schoolAxios({
            method: 'delete',
            url: 'place/delete/'+id,
            params: {}
          }).then(function (resp) {
            let data = resp.data;
            if(data.success){
              this_.initRoomListData();
            }else{
              data.message.showMessage();
            }
          });
        });
      },
      /**
       * 修改场地信息
       */
      update_Place(){
        let this_ = this;
        this_.$validator.validateAll('place').then(result => {
          if (result) {
            schoolAxios({
              method: 'put',
              url: 'place/edit',
              data: {
                'id': this_.current_placeId,
                'name': this_.place.name,
                'type': this_.place.type
              }
            }).then(function (resp) {
              let data = resp.data;
              if (data.success) {
                "修改成功".showMessage();
                this_.isAddTeacher = false;
                this_.initRoomListData();
                $("#updatePlaceModal").modal('hide');
              } else {
                data.message.showMessage();
              }
            });
          }
        });
      },
      deleteRoomById(){
        let this_=this;
        schoolAxios({
          method:'delete',
          url: 'rooms/delete/'+this_.deleteRoomId,
          data:{
          }
        }).then(function (response) {
          let data = response.data;
          if(data.success){
            this_.initRoomListData();
          }else{
            data.message.showMessage();
          }
        });
      },

      openAddRoomModal(){
        let this_ = this;
        this_.rooms = {
          id: '',
          placeId: '',
          name: '',
          clazzNum: '',
        };
      },

      /**
       * 关闭模态框监听
       */
      closeModal() {
        let this_ = this;
        $("#addPlaceModal").on('hide.bs.modal', function () {
          this_.place = {
            id: '',
            name: '',
            type: '',
          };

          setTimeout(function () {
            this_.errors.clear('place');
          });

        });
        $("#updatePlaceModal").on('hide.bs.modal', function () {

          this_.place = {
            id: '',
            name: '',
            type: '',
          };

          setTimeout(function () {
            this_.errors.clear('place');
          });

        });
        $("#roomModel").on('hide.bs.modal', function () {
          this_.rooms = {
            id: '',
            placeId: '',
            name: '',
            clazzNum: '',
          };

          setTimeout(function () {
            this_.errors.clear('rooms');
          });

        });
      },
    }
  }
</script>

<style scoped>
  @import '../assets/css/plugins.css';
  @import "../assets/css/publicStyle.css";
  @import "../assets/css/placeSetting.css";
</style>



// WEBPACK FOOTER //
// src/components/placeSetting.vue